export class DynamoDBRestoreMethodAvailabilityResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "available",
            "baseName": "available",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reasons",
            "baseName": "reasons",
            "type": "Array<RestoreMethodAvailabilityReason>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDBRestoreMethodAvailabilityResponse.attributeTypeMap;
    }
    constructor() {
    }
}
